module.exports = __webpack_public_path__ + "img/network.0435f1e3.svg";